export default class FontControllers {
	constructor(content, increaseButton, decreaseButton) {
		this.handleFontControllers(content, increaseButton, decreaseButton);
	}

	increaseFontSize(content) {
		let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue('font-size'));

		if (currentFontSize < 22) {
			content.style.fontSize = (currentFontSize + 1) + 'px';
		}
	}

	forceFontSize(content, value = 16) {
		let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue('font-size'));

		if (currentFontSize <= 22 && currentFontSize >= 8) {
			content.style.fontSize = `${value}px`;
		}
	}

	decreaseFontSize(content) {
		let currentFontSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue('font-size'));
		if (currentFontSize > 8) {
			content.style.fontSize = (currentFontSize - 1) + 'px';
		}
	}

	handleFontControllers(content, increaseButton, decreaseButton) {
		content.querySelectorAll('*').forEach(child => {
			this.forceFontSize(child, 16);
		});

		increaseButton.addEventListener('click', () => {
			this.increaseFontSize(content);

			content.querySelectorAll('*').forEach(child => {
				this.increaseFontSize(child);
			});
		});

		decreaseButton.addEventListener('click', () => {
			this.decreaseFontSize(content);

			content.querySelectorAll('*').forEach(child => {
				this.decreaseFontSize(child);
			});
		});
	}
}
